import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import LoaderPage from './pages/LoaderPage';
import SignupPage from './pages/SignupPage';
import ActivitiesPage from './pages/ActivitiesPage';
import CreateProfilePage from './pages/CreateProfilePage';
import OnboardingStep1Page from './pages/OnboardingStep1Page';
import OnboardingStep2Page from './pages/OnboardingStep2Page';
import SignupCompletedPage from './pages/SignupCompletedPage';
import LoginPage from './pages/LoginPage';
import MainPage from './pages/MainPage';
import GameTest from './pages/GameTest';
import ProfilePage from './pages/ProfilePage';
import WalletPage from './pages/WalletPage';
import ClaimPrizePage from './pages/ClaimPrizePage';
import PrizeDetailsPage from './pages/PrizeDetailsPage';
import FirebaseTestPage from './pages/FirebaseTestPage';
import CampaignDuplicatorPage from './pages/CampaignDuplicatorPage';
import MigrationPage from './pages/MigrationPage';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

// Component to handle route changes and notify parent iframe
function RouteChangeHandler() {
  const location = useLocation();

  useEffect(() => {
    // Notify parent window about route change (height might have changed)
    // This works with wiin-messenger.js
    window.dispatchEvent(new CustomEvent('wiin-height-change'));
    window.dispatchEvent(new CustomEvent('wiin-scroll-top'));
  }, [location.pathname]);

  return null;
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <RouteChangeHandler />
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LoaderPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/create-profile" element={<CreateProfilePage />} />
          
          {/* Protected Routes - Require Authentication */}
          <Route path="/onboarding/step-1" element={
            <ProtectedRoute>
              <OnboardingStep1Page />
            </ProtectedRoute>
          } />
          <Route path="/onboarding/step-2" element={
            <ProtectedRoute>
              <OnboardingStep2Page />
            </ProtectedRoute>
          } />
          <Route path="/signup-completed" element={
            <ProtectedRoute>
              <SignupCompletedPage />
            </ProtectedRoute>
          } />
          <Route path="/activities" element={
            <ProtectedRoute>
              <ActivitiesPage />
            </ProtectedRoute>
          } />
          <Route path="/main" element={
            <ProtectedRoute>
              <MainPage />
            </ProtectedRoute>
          } />
          <Route path="/game/:campaignId" element={
            <ProtectedRoute>
              <GameTest />
            </ProtectedRoute>
          } />
          <Route path="/game-test" element={
            <ProtectedRoute>
              <GameTest />
            </ProtectedRoute>
          } />
          <Route path="/claim-prize/:campaignId" element={
            <ProtectedRoute>
              <ClaimPrizePage />
            </ProtectedRoute>
          } />
          <Route path="/prize/:prizeId" element={
            <ProtectedRoute>
              <PrizeDetailsPage />
            </ProtectedRoute>
          } />
          <Route path="/profil" element={
            <ProtectedRoute>
              <ProfilePage />
            </ProtectedRoute>
          } />
          <Route path="/wallet" element={
            <ProtectedRoute>
              <WalletPage />
            </ProtectedRoute>
          } />
          
          {/* Admin/Development Routes - Also Protected */}
          <Route path="/firebase-test" element={
            <ProtectedRoute>
              <FirebaseTestPage />
            </ProtectedRoute>
          } />
          <Route path="/campaign-duplicator" element={
            <ProtectedRoute>
              <CampaignDuplicatorPage />
            </ProtectedRoute>
          } />
          <Route path="/migration" element={
            <ProtectedRoute>
              <MigrationPage />
            </ProtectedRoute>
          } />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App; 